<template>
  <div class="login-container">
    <div class="container-login100">
      <div class="wrap-login100">
        <div class="login100-pic" data-tilt>
          <img :src="require('@/assets/img-01.png')" alt="IMG" />
        </div>

        <el-form :model="loginForm" status-icon :rules="loginRules" id="loginForm" ref="loginForm" :class="!showForgot ? 'showForm' : 'hideForm'">
          <span class="login100-form-title"> ABBS Login </span>
          <el-form-item prop="email">
            <el-input prefix-icon="el-icon-message" type="text" v-model="loginForm.email" placeholder="Email" @keyup.enter.native="$refs.inputpassword.focus()" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input prefix-icon="el-icon-lock" ref="inputpassword" type="password" v-model="loginForm.password" placeholder="Password" @keyup.enter.native="Login"  autocomplete="off" show-password></el-input>
          </el-form-item>

          <el-form-item>
            <div class="container-login100-form-btn">
              <el-button :loading="loading" class="login100-form-btn" type="primary" @click="Login">Login</el-button>
            </div>
            <div class="text-center p-t-12">
						<span class="txt1">
							
						</span>
            <el-button type="text" @click="changeForm(true)">Forgot your Password?</el-button>
					</div>
          </el-form-item>
        </el-form>

        <el-form :model="forgotForm" status-icon :rules="forgotRules" id="forgotForm" ref="forgotForm" :class="showForgot ? 'showForm' : 'hideForm'">
            <span class="login100-form-title"> Forgot your password? </span>
            <el-form-item prop="email" label="Please, enter your email address">
              <el-input prefix-icon="el-icon-message" type="text" v-model="forgotForm.email" placeholder="Email" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item>
              <div class="container-login100-form-btn">
                <el-button :loading="loadingForgot" class="login100-form-btn" type="primary" @click="Forgot">Continue</el-button>
              </div>
              <div class="text-center p-t-12">
                <el-button type="text" @click="changeForm(false)"> Go back to the sign in page</el-button>
					    </div>
          </el-form-item>
        </el-form>

      </div>
    </div>
  </div>
</template>

<script>
import {getToken, forgotPassword} from '@/api/user'
export default {
  data(){
    return{
      loading: false,
      loadingForgot: false,
      showForgot: false,
      loginForm: {
        email: '',
        password: '',
        token: ''
      },
      forgotForm: {
        email: ''
      },
      loginRules: {
        email: [{
            required: true,
            message: "Please enter your email",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Please enter correct email format",
            trigger: "blur",
          }],
        password: [{ required: true, message: "Please enter your password", trigger: "blur" }],
       
      },
      forgotRules: {
        email: [{
            required: true,
            message: "Please enter your email",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Please enter correct email format",
            trigger: "blur",
          }]
      },
      redirect: undefined,
      otherQuery: {}
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  methods:{
    getServerToken(){
      getToken().then(res => {
        if(res && res['result']){
          this.loginForm.token = res['data']['token']
        }
      });
    },
    Login(){
      this.$refs.loginForm.validate((valid) => {
        if(valid){
          this.loading = true
          this.$store.dispatch('user/login', this.loginForm)
            .then((res) => {
              if(res && res.result && !res.data.token) {
                let url = {
                  "2fa" : "two-factor-authentication",
                  "sms" : "sms-authentication"
                }
                
                this.$router.push(`/login/${url[res.data.redirectPage]}/${res.data.uid}`)
                
              }else{
                if(res && res.result){
                  this.$router.push({ path: this.redirect || '/', query: this.otherQuery })
                }else{
                  this.getServerToken()
                }

              }

              
              this.loading = false
            })
            .catch((err) => {
              console.log(err)
              this.loading = false
              this.getServerToken()
            })
        } else {
          console.log('error submit!!')
          return false
        }
        
      })
    },
    Forgot(){
      this.$refs.forgotForm.validate((valid) => {
        if(valid){
          this.loadingForgot = true
          forgotPassword(this.forgotForm).then(({result, message}) => {
            this.loadingForgot = false
            if(result){
              this.$router.push({ path: '/lost-password' })
            }
          })
            
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
    changeForm(showForgot){
      this.showForgot = showForgot
      if(this.$refs.forgotForm) this.$refs.forgotForm.resetFields()
      if(this.$refs.loginForm) this.$refs.loginForm.resetFields()
    }
  },
  created(){
    this.getServerToken()
  }
};
</script>

<style lang="scss">
@import "~@/styles/login.scss";

.login-container{
  .showForm{
    display: block;
  }

  .hideForm{
    display: none;
  }
}
</style>
